import Cookies from 'js-cookie';

const defaultOptions = { path: '/' };

export function setCookie({ key, value, ...options }) {
  Cookies.set(key, value, { ...defaultOptions, ...options });
}

export function getCookie(key) {
  return Cookies.get(key);
}

export function removeCookie({ key, ...options }) {
  Cookies.remove(key, { ...defaultOptions, ...options });
}
